import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";
import { Image } from "primereact/image";
import { useEffect, useRef, useState } from "react";

import {
  buttonHide,
  buttonShowAll,
  panelLabelUsedSource,
  panelLabelUsedSources,
  labelNoSourceUsed,
  labelNoAnswerFromAI,
  errorMessaggeAi,
} from "_constants";
import { getAnswerTypeGrey, getTypeToneOfVoice } from "utils";
import { ActionsAnswer } from "./ActionsAnswer";
import { Question } from "interfaces";
import avatarEsophia from "./../../../../../assets/icons/icon_avatar_esophia.svg";
import toneVoiceIcon from "assets/icons/icon_tone_of_voice.svg";
import {
  DetailRepliedAnswer,
  SourceTypeChip,
  WaitMessaggeAnimation,
  ReactMarkdownAI,
} from "components/shared";
import { useAppDispatch, useAppSelector } from "store/store";
import { setNewMessage } from "store/slicer/GestioneChatSlice";

export const AnswerItem = ({
  item,
  filters,
  index,
  numberAnswerSelected,
  onAnswerSelect,
  isLast,
  selectorId,
}: {
  item: Question;
  filters: {
    projectId: string;
    pageIndex: number;
    pageSize: number;
  };
  index: number;
  numberAnswerSelected: number;
  onAnswerSelect: (index: number) => void;
  isLast: boolean;
  selectorId: string;
}) => {
  const dispatch = useAppDispatch();
  const [showAll, setShowAll] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [answerType, setAnswerType] = useState<{
    icon: string;
    name: string;
  }>();
  const waitMessage = useAppSelector(
    (state) => state.gestioneChatSlice.waitMessage
  );
  const newMessage = useAppSelector(
    (state) => state.gestioneChatSlice.newMessage
  );
  const errorMessage = useAppSelector(
    (state) => state.gestioneChatSlice.errorMessage
  );
  const [partialMessage, setPartialMessage] = useState("");
  const fullMessage = item.answersList[numberAnswerSelected]?.message || "";

  useEffect(() => {
    const checkOverflow = () => {
      const container = containerRef.current;
      if (container) {
        setIsOverflowing(container.scrollHeight > container.clientHeight);
      }
    };

    checkOverflow();

    window.addEventListener("resize", checkOverflow);

    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, []);

  useEffect(() => {
    let index = 0;
    if (newMessage && isLast) {
      setPartialMessage("");
      const intervalId = setInterval(() => {
        if (index < fullMessage.length) {
          setPartialMessage((prev) => prev + fullMessage[index]);
          index++;
        } else {
          clearInterval(intervalId);
          dispatch(setNewMessage(false));
        }
      }, 0);

      return () => clearInterval(intervalId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newMessage, fullMessage, selectorId]);

  useEffect(() => {
    setAnswerType(getAnswerTypeGrey(item.answerType));
  }, [item.answerType]);

  return (
    <div className="width-100" key={index}>
      <div className="width-100 padd-top-18 flex-container column gap-18 padd-bottom-18 align-end">
        <div className="flex-container gap-8">
          <Image src={answerType?.icon} width="16" height="16" />
          <span className="text-regular-blue-disable">{answerType?.name}</span>
        </div>
        {item.repliedAnswer && (
          <DetailRepliedAnswer
            repliedAnswer={item.repliedAnswer}
            className="max-width-65"
          />
        )}
        <div className="question">
          <span className="break-wrap-word">{item?.message ?? ""}</span>
        </div>
      </div>
      <div className="width-100 padd-top-18 padd-bottom-18">
        {(errorMessage &&
          !item.answersList[numberAnswerSelected]?.message &&
          isLast) ||
        (!isLast && !item.answersList[numberAnswerSelected]?.message) ? (
          <div className="flex-container gap-18">
            <Image src={avatarEsophia} width="24px" height="24px" />
            <span className="text-regular-blue margin-top-4 break-wrap-word">
              {errorMessaggeAi}
            </span>
          </div>
        ) : (
          <div className="container-answer">
            <Image src={avatarEsophia} width="24px" height="24px" />
            {waitMessage && isLast && <WaitMessaggeAnimation />}
            {(!waitMessage || !isLast) && (
              <div id={selectorId} className="answer">
                <span className="text-regular-blue margin-top-4 break-wrap-word">
                  {isLast && newMessage ? (
                    partialMessage
                  ) : (
                    <ReactMarkdownAI
                      message={item.answersList[
                        numberAnswerSelected
                      ]?.message?.replace(/\n/g, "  \n  ")}
                    />
                  )}
                </span>
                {(!newMessage || !(isLast && newMessage === true)) && (
                  <>
                    <div
                      className={`${
                        !item.answersList[numberAnswerSelected]?.sourcesList
                          ? ""
                          : "margin-top-36 margin-bottom-14"
                      }`}
                    >
                      <span
                        className={`text-regular-blue ${
                          item.answersList[numberAnswerSelected]?.sourcesList
                            ?.length === 0
                            ? "italic"
                            : ""
                        }`}
                      >
                        {!item.answersList[numberAnswerSelected]?.sourcesList
                          ? null
                          : item.answersList[numberAnswerSelected]?.sourcesList
                              ?.length === 0 ||
                            item.answersList[numberAnswerSelected]?.message ===
                              labelNoAnswerFromAI
                          ? labelNoSourceUsed
                          : `${
                              item.answersList[numberAnswerSelected]
                                ?.sourcesList?.length
                            } ${
                              item.answersList[numberAnswerSelected]
                                ?.sourcesList?.length === 1
                                ? panelLabelUsedSource
                                : panelLabelUsedSources
                            }`}
                      </span>
                    </div>
                    {item.answersList[numberAnswerSelected]?.message &&
                      item.answersList[numberAnswerSelected]?.message !==
                        labelNoAnswerFromAI && (
                        <div
                          ref={containerRef}
                          className={`container-source-answer ${
                            showAll ? "" : "max-height-52"
                          }`}
                        >
                          {item.answersList[
                            numberAnswerSelected
                          ]?.sourcesList?.map((source, sourceIndex) => (
                            <SourceTypeChip
                              type={source.type}
                              name={source.name}
                              stateUpdate={source.stateUpdate}
                              key={sourceIndex}
                            />
                          ))}
                        </div>
                      )}
                    {isOverflowing && (
                      <Button
                        onClick={() => setShowAll(!showAll)}
                        icon={
                          showAll ? PrimeIcons.ANGLE_UP : PrimeIcons.ANGLE_DOWN
                        }
                        link
                        className="width-max-content padd-0 gap-4 height-px-17 font-weight-700 box-shadow-none margin-top-14"
                      >
                        {showAll ? buttonHide : buttonShowAll}
                      </Button>
                    )}
                    <div className="flex-container margin-top-36 gap-14 width-100 align-center">
                      <ActionsAnswer
                        answer={item.answersList[numberAnswerSelected]}
                        projectId={filters.projectId}
                        numberAnswerSelected={numberAnswerSelected}
                        lenghtAnswers={item.answersList.length}
                        callback={(answerSelected: number) => {
                          onAnswerSelect(answerSelected);
                        }}
                        isDisabled={!item.answersList[numberAnswerSelected].isActive}
                        isLast={isLast}
                        questionId={item.id!}
                        showActions={
                          item.answersList[numberAnswerSelected]?.sourcesList
                            ?.length &&
                          item.answersList[numberAnswerSelected]?.message &&
                          item.answersList[numberAnswerSelected]?.message !==
                            labelNoAnswerFromAI
                            ? true
                            : false
                        }
                      />
                      {item.answersList[numberAnswerSelected]?.sourcesList
                        ?.length > 0 &&
                        item.answersList[numberAnswerSelected]?.message &&
                        item.answersList[numberAnswerSelected]?.message !==
                          labelNoAnswerFromAI && (
                          <>
                            <div className="width-px-1 height-px-28 bg-grey action-answer "></div>
                            <div className="flex-container gap-4 action-answer ">
                              <Image src={toneVoiceIcon} alt="" />
                              <span className="text-base-regular font-weight-500 italic">
                                {getTypeToneOfVoice(
                                  item.answersList[numberAnswerSelected]
                                    ?.toneOfVoice
                                )}
                              </span>
                            </div>
                          </>
                        )}
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
